import { KdsTicket, TicketStatus } from '../types/ticket';

export const filterDisplayingTicketByStatus = (tickets: KdsTicket[]): KdsTicket[] =>
    tickets.filter(({ status }) => status === TicketStatus.Displaying);
